import React from 'react';
import withWidget from './with-widget';

function SwellParagraph({ field }) {
  return <p>{field.label}</p>;
}

export default withWidget(SwellParagraph);